import { Stack, Typography } from '@mui/material'
import { COLORS } from 'app-constants'

const ViewTabs = ({
  tabIndex,
  setTabIndex,
  tabs,
}: {
  tabIndex: number
  setTabIndex: React.Dispatch<React.SetStateAction<number>>
  tabs: string[]
}) => {
  return (
    <Stack
      direction="row"
      width="258px"
      p="4px"
      alignItems="flex-start"
      gap="10px"
      borderRadius="10px"
      sx={{
        background: COLORS.GRAY_8,
      }}>
      {tabs.map((tab, index) => (
        <Stack
          key={index}
          width="120px"
          alignItems="center"
          onClick={() => setTabIndex(index)}
          p="6px 17px"
          borderRadius="10px"
          sx={{
            cursor: 'pointer',
            background: tabIndex === index ? '#fff' : 'transparent',
            boxShadow: tabIndex === index ? '1px 1px 2px 0px rgba(0, 0, 0, 0.08)' : 'none',
          }}>
          <Typography
            variant="pSM"
            sx={{
              color: tabIndex !== index ? COLORS.GRAY_3 : COLORS.GRAY_0,
            }}>
            {tab}
          </Typography>
        </Stack>
      ))}
    </Stack>
  )
}

export default ViewTabs
